import { apiClient } from "../../base/ApiClient";

//  Fetch client suggestions

export const fetchClientSuggestions = async (clientInput) => {
  const res = await apiClient.get(`/users/client/filter?name=${clientInput}`);
  return res.data.clients;
};

// Fetch candidate suggestions
export const fetchCandidateSuggestions = async (candidateInput) => {
  const res = await apiClient.get(
    `/users/candidate/filter/?name=${candidateInput}`
  );
  return res.data.candidates;
};

// Create event
export const createEvent = async (eventData) => {
  const response = await apiClient.post(
    `/communications/event/create`,
    eventData
  );
  return response.data;
};

//get event for showing on ReactBigCalender.js
export const fetchCreatedEventData = async () => {
  const res = await apiClient.get(`/communications/users/events`);
  return res.data;
};

// edit event data
export const updateEventData = async (contactId, formData) => {
  const response = await apiClient.put(
    `/client/personal-contacts/${contactId}/`,
    formData
  );
  return response.data;
};

// delete event data
export const deleteEventData = async (contactId) => {
  const response = await apiClient.delete(
    `/client/personal-contacts/${contactId}/`
  );
  return response.data;
};
